import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';

const PythonTechnologiesTools = () => {
    return (
        <div className="section-py bg-grey dark:bg-black overflow-x-hidden">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-11">
                    <div className="lg:col-span-12 text-center">
                        <h2 className="">Technologies and Tools We Use</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 technologies-tools-tab overflow-x-hidden">
                    <div className="lg:col-span-12 grid">
                        <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="Python Frameworks">
                                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-django.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Django"
                                            title="Django"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">Django</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-flask.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Flask"
                                            title="Flask"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">Flask</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-fastapi.svg"
                                            className="img-fluid mb-2.5"
                                            alt="FastAPI"
                                            title="FastAPI"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">FastAPI</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Python Libraries">
                                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-pandas.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Pandas"
                                            title="Pandas"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">Pandas</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-numpy.svg"
                                            className="img-fluid mb-2.5"
                                            alt="NumPy"
                                            title="NumPy"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">NumPy</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-tensorflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="TensorFlow"
                                            title="TensorFlow"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">TensorFlow</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Databases">
                                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-postgresql.svg"
                                            className="img-fluid mb-2.5"
                                            alt="PostgreSQL"
                                            title="PostgreSQL"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">PostgreSQL</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-mysql.svg"
                                            className="img-fluid mb-2.5"
                                            alt="MySQL"
                                            title="MySQL"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">MySQL</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-mongodb.svg"
                                            className="img-fluid mb-2.5"
                                            alt="MongoDB"
                                            title="MongoDB"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">MongoDB</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Cloud Platforms">
                                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-aws.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AWS"
                                            title="AWS"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">AWS</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-azure.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure"
                                            title="Azure"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">Azure</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-google-cloud.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google Cloud"
                                            title="Google Cloud"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">Google Cloud</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Front-End Technologies">
                                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-react.svg"
                                            className="img-fluid mb-2.5"
                                            alt="React"
                                            title="React"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">React</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-angular.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Angular"
                                            title="Angular"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">Angular</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-vuejs.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Vue.js"
                                            title="Vue.js"
                                            height={50}
                                            width={50}
                                        />
                                        <p className="fs-md fw-600 mb-0">Vue.js</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PythonTechnologiesTools;
